<!----
    Author: hjlee
    Description:
        메모 댓글 컨트롤
---->
<template>
  <div class="memo-comment-area">
    <div v-if="memoComment.code" class="memo-comment-contents">
      {{ $t(memoComment.code, JSON.parse(memoComment.paramtr)) }}
    </div>
    <div v-else class="memo-comment-contents">
      <div v-if="mode === 'view'" v-html="memoComment.cn" />
      <input-control
        v-else
        v-model="memoCommentTarget.cn"
        :required="true"
        name="cn"
        type="html_editor"
        :editor-options="editorOptions"
        :no-title="true"
        :placeholder="$t('column.nm.cn')"
        :title="$t('column.nm.cn')"
      />
    </div>
    <div v-if="mode === 'modify'" class="update-control-area">
      <button class="btn-sm btn-primary" @click="updateMemoCommentConfirm($event)">
        {{ $t('common.button.save') }}
      </button>
      <button class="btn-sm btn-secondary" @click="cancelModification($event)">
        {{ $t('common.button.cancel') }}
      </button>
    </div>
    <div v-for="(file, fileIndex) in memoComment.attachments" :key="'file-' + file.id + '-' + fileIndex" class="file-item">
      <a class="clickable" @click="downloadFileWithTmpId(file.tmpId, file.fileNm, file)">
        <file-icon :filename="file.fileNm" scale="extra-small" />
        {{ file.fileNm }}
        <span class="download-count">
          <i class="fa fa-download" /> {{ file.dwldCo }}
        </span>
      </a>
    </div>
    <div v-if="memoComment.rgsOperId === loggedInUser.id" class="modify-memo-control-area">
      <a @click="modifyMemoComment($event)">
        <i class="fa fa-pencil" />
      </a>
      <a @click="deleteMemoCommentConfirm($event)">
        <i class="fa fa-trash" />
      </a>
    </div>
    <div class="memo-comment-registration-operation-datetime">
      <span v-if="memoComment.writer" class="writer-name">{{ memoComment.writer.nm }}</span>
      <span v-else class="writer-name">{{ $t('common.text.deleted_user') }}</span> -
      {{ memoComment.rgsOperDt | formatDatetime }}
    </div>
    <b-modal
      id="update-confirm-modal"
      ref="updateConfirmModalRef"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="true"
      :no-close-on-backdrop="true"
      @ok="updateMemoComment"
    >
      <p class="my-4" v-html="$t('common.modal.text.update_confirm')" />
    </b-modal>
    <b-modal
      id="delete-confirm-modal"
      ref="deleteConfirmModalRef"
      :title="$t('common.modal.title.confirm')"
      :ok-title="$t('common.button.ok')"
      :cancel-title="$t('common.button.cancel')"
      :lazy="true"
      :no-close-on-backdrop="true"
      @ok="deleteMemoComment"
    >
      <p class="my-4" v-html="$t('common.modal.text.delete_confirm')" />
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    memoComment: {
      type: Object,
      required: true
    },
    useCharger: {
      type: Boolean,
      default: false
    },
    useAttachment: {
      type: Boolean,
      default: true
    },
    editorOptions: {
      type: Object,
      default: undefined
    },
    type: {
      type: String,
      default: 'normal'
    }
  },
  data() {
    return {
      mode: 'view',
      memoCommentTarget: {}
    }
  },
  methods: {
    modifyMemoComment(e) {
      e.preventDefault()
      e.stopPropagation()
      this.memoCommentTarget = window.copyObject(this.memoComment)
      this.mode = 'modify'
    },
    async updateMemoCommentConfirm(e) {
      e.preventDefault()
      e.stopPropagation()
      if (
        !(await this.validateUnder(
          $(this.$el)
            .find('.memo-comment-contents')
            .get(0),
          '.app-body'
        ))
      ) {
        return
      }
      this.showModal('updateConfirmModalRef')
    },
    deleteMemoCommentConfirm(e) {
      e.preventDefault()
      e.stopPropagation()
      this.showModal('deleteConfirmModalRef')
    },
    cancelModification(e) {
      e.preventDefault()
      e.stopPropagation()
      this.mode = 'view'
    },
    updateMemoConfirm(e) {
      e.preventDefault()
      e.stopPropagation()
      this.showModal('updateConfirmModalRef')
    },
    updateMemoComment() {
      this.$axios
        .$put('/memo/memoComment', this.memoCommentTarget)
        .then(response => {
          if (response.resultCode === 'success') {
            this.$toast.info(this.$t(response.message, response.params))
            this.$emit('updated', this.memoCommentTarget)
            this.mode = 'view'
          } else {
            console.error(this.$t(response.message, response.params))
            this.$toast.error(this.$t(response.message, response.params))
          }
        })
    },
    deleteMemoComment() {
      this.$axios
        .$put('/memo/deleteMemoComment', this.memoComment)
        .then(response => {
          if (response.resultCode === 'success') {
            this.$toast.info(this.$t(response.message, response.params))
            this.$emit('deleted', this.memoComment)
          } else {
            console.error(this.$t(response.message, response.params))
            this.$toast.error(this.$t(response.message, response.params))
          }
        })
    }
  }
}
</script>

<style scoped>
.memo-comment-area {
  border: 1px solid #eeeeee;
  padding: 10px;
}
.memo-comment-registration-operation-datetime {
  font-size: 0.7rem;
  color: #999999;
  text-align: right;
}
.memo-comment-contents {
  word-break: break-all;
  white-space: normal;
}
.modify-memo-control-area {
  float: left;
}
.modify-memo-control-area a {
  margin-right: 10px;
}
.writer-name {
  font-size: 0.7rem;
  color: #999999;
}
.update-control-area {
  text-align: right;
}
</style>
